import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ResearcherContext } from "./ResearcherContext";
import { CompanyContext } from "./CompanyContext";
import { useAlert } from 'react-alert';


import { ProtectedRoute, PreAuthRoute } from "./utility_components/auth_routes";
import ScrollToTop from "./utility_components/ScrollToTop";

import Dashboard from "./main_portal/pages/Dashboard";
import CreateMission from "./main_portal/pages/CreateMission";
import SignIn from "./preauth_portal/pages/SignIn";
import SignUp from "./preauth_portal/pages/SignUp";
import ForgotPassword from "./preauth_portal/pages/ForgotPassword";
import ResetPassword from "./preauth_portal/pages/ResetPassword";
import HeaderResearcher from "./main_portal/components/common_components/HeaderResearcher";
import HeaderPreAuth from "./preauth_portal/components/HeaderPreAuth";
import Mission from "./main_portal/pages/Mission";
import NotFound from "./utility_components/NotFound";

import JoinMeetingContent from "./meetings/JoinMeetingsContent";

import PricingTable from "./main_portal/components/stripe_components/PricingTable";

// API Calls
import sessionAPI from "./preauth_portal/api/api_calls/sessionAPI";


function ResearcherApp(props) {
    const [researcher, setResearcher] = useState({});
    const [company, setCompany] = useState({});

    const [needResearcherRefresh, setNeedResearcherRefresh] = useState(true);
    const [needCompanyRefresh, setNeedCompanyRefresh] = useState(true);


    function refreshResearcher() {
        setResearcher({});
        setNeedResearcherRefresh(true);
    }

    function refreshCompany() {
        setCompany({});
        setNeedCompanyRefresh(true);
    }

    const researcherContextData = { researcher, setResearcher, refreshResearcher }
    const companyContextData = { company, setCompany, refreshCompany }

    const alert = useAlert();


    useEffect(() => {
        // App loaded.
        // Grab initial information on the researcher.
        async function getResearcherInfo() {
            const response = await sessionAPI.researcherInfo();

            if (response.success) {
                setResearcher(response);
            } else {
                alert.show("Unable to load researcher info. Please try again later", { type: 'error' })
            }
        }

        if (needResearcherRefresh) {
            getResearcherInfo();
            setNeedResearcherRefresh(false);
        }
    }, [needResearcherRefresh]);

    useEffect(() => {
        // App loaded.
        // Grab information on the company
        async function getCompanyInfo() {
            const response = await sessionAPI.companyInfo();

            if (response.success) {
                setCompany(response);
            } else {
                alert.show("Unable to load researcher info. Please try again later", { type: 'error' })
            }
        }

        if (needCompanyRefresh) {
            getCompanyInfo();
            setNeedCompanyRefresh(false);
        }
    }, [needCompanyRefresh]);





    return (
        <ResearcherContext.Provider value={researcherContextData}>
            <CompanyContext.Provider value={companyContextData}>
                <BrowserRouter basename="/researcher">
                    <ScrollToTop />

                    <Routes>
                        <Route element={<PreAuthRoute />} >
                            <Route path="/signin" element={<><HeaderPreAuth /><SignIn /></>} />
                            <Route path="/signup/*" element={<SignUp />} />
                            <Route path='/forgotpassword' element={<><HeaderPreAuth /><ForgotPassword /></>} /> {/* This is the requesting page */}
                            <Route path='/resetpassword' element={<><HeaderPreAuth /><ResetPassword /></>} /> {/* This is the setting page (post-email) */}
                        </Route>

                        {/* These are the auth routes - only available when logged in */}
                        <Route element={<ProtectedRoute />} >
                            <Route path="/dashboard" element={<><HeaderResearcher /><Dashboard /></>} />
                            {/* <Route path="/subscription" element={<><HeaderResearcher /><PricingTable /></>} /> */}

                            <Route path="/createmission/*" element={<><CreateMission /></>} />
                            <Route path="/missions/:missionId/*" element={<Mission />} />
                            {/* This is the default route - if no other route is matched, this will be rendered */}
                            <Route path="*" element={<><HeaderResearcher /> <NotFound /></>} />
                        </Route>

                        {/* This is the route for joining scheduled events. Auth is optional.  */}
                        <Route path='/meetings/:meetingSlug' element={<><HeaderPreAuth /><JoinMeetingContent /></>} />


                        {/* This is the default route - if no other route is matched, this will be rendered */}
                        {/* For now, we redirect */}
                        {/* <Route path="*" element={<PageNotFound />} /> */}

                    </Routes>
                </BrowserRouter>
            </CompanyContext.Provider>
        </ResearcherContext.Provider>
    )
}


export default ResearcherApp;